export default {
  loggedUser: {},
  loggedIn: {
    as: '',
    active: false
  },
};
